









import type { PropType } from '@vue/composition-api';
import { toRefs, computed, defineComponent } from '@vue/composition-api';
import { AvatarSize } from '@getaccept/lib-ui';
import { AvatarHelper } from '@getaccept/lib-shared/src/helpers/avatars.helper';
import type { ChatParticipant, Conversation, Typing } from '../types';
import { ChatHelper } from '../helpers';

export default defineComponent({
  name: 'ChatTypingStatus',
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: undefined,
    },
    owner: {
      type: Object as PropType<ChatParticipant>,
      default: undefined,
    },
    typing: {
      type: Array as PropType<Array<Typing>>,
      default: () => [],
    },
  },
  setup(props) {
    const { conversation, typing, owner } = toRefs(props);
    const avatars = computed(() =>
      typing.value
        .filter(
          ({ conversationId, participant }) =>
            conversationId === conversation.value.id &&
            !ChatHelper.isSameParticipant(participant, owner.value) &&
            (participant.recipient || participant.user)
        )
        .map(({ participant }) => {
          if (participant.recipient) {
            return {
              name: AvatarHelper.getDisplayName(participant.recipient),
              thumbUrl: participant.recipient.thumbUrl,
            };
          }
          return {
            name: AvatarHelper.getDisplayName(participant.user),
            thumbUrl: participant.user.thumbUrl,
          };
        })
    );

    return { avatars, AvatarSize };
  },
});
